import { Logo, Avatar } from "./Bits";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogOut, Bell } from "lucide-react";
import * as Icons from "lucide-react";

function NavIcon({ name, ...p }) {
  const I = Icons[name] || Icons.Circle;
  return <I {...p} />;
}

export default function PortalShell({ nav, active, setActive, title, accent = "coral", children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const activeCls = accent === "sage" ? "bg-sage text-white" : "bg-coral text-white";

  return (
    <div className="min-h-screen flex bg-ivory">
      <aside className="w-[240px] shrink-0 bg-ink text-ivory flex-col hidden md:flex sticky top-0 h-screen">
        <div className="p-5 border-b border-white/10">
          <Logo light />
          <div className="flex items-center gap-3 mt-4">
            <Avatar initials={(user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("")} gradient="linear-gradient(140deg,#EC5E3F,#F4C45D)" size={40} />
            <div className="min-w-0">
              <p className="text-sm font-semibold truncate">{user?.name}</p>
              <p className="text-xs text-ivory/50 truncate">{user?.city || user?.role}</p>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto no-scrollbar">
          {nav.map((n) => (
            <button key={n.key} onClick={() => setActive(n.key)} data-testid={`nav-${n.key}`}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-r text-sm font-medium transition-colors ${active === n.key ? activeCls : "text-ivory/70 hover:bg-white/5"}`}>
              <NavIcon name={n.icon} size={17} /> {n.label}
            </button>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-r text-sm text-ivory/70 hover:bg-white/5" data-testid="portal-logout">
            <LogOut size={17} /> Log Out
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <div className="h-16 bg-card border-b border-line flex items-center justify-between px-6 sticky top-0 z-30">
          <h1 className="text-lg font-display font-bold">{title}</h1>
          <div className="flex items-center gap-4">
            <Bell size={18} className="text-ink-soft" />
            <Avatar initials={(user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("")} gradient="linear-gradient(140deg,#7C9A78,#5E7C5B)" size={34} />
          </div>
        </div>

        {/* mobile nav */}
        <div className="md:hidden flex gap-2 overflow-x-auto p-3 bg-card border-b border-line no-scrollbar">
          {nav.map((n) => (
            <button key={n.key} onClick={() => setActive(n.key)}
              className={`whitespace-nowrap text-xs px-3 py-2 rounded-full ${active === n.key ? activeCls : "bg-ivory-2 text-ink-soft"}`}>{n.label}</button>
          ))}
        </div>

        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
